/* Tipli API istemcisi. Site herkese açık; yalnızca editör uçları çerez ister. */

import type { SiteContent } from "../shared/types.js";

export class ApiError extends Error {
  status: number;
  code: string;
  constructor(status: number, code: string, message: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: "same-origin",
    headers: init?.body ? { "content-type": "application/json" } : undefined,
    ...init,
  });
  const text = await res.text();
  const body = text ? safeJson(text) : null;
  if (!res.ok) {
    const err = (body ?? {}) as { error?: string; message?: string };
    throw new ApiError(
      res.status,
      err.error ?? "error",
      err.message ?? "Bir şeyler ters gitti. Tekrar deneyin.",
    );
  }
  return body as T;
}

function safeJson(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

export const api = {
  content: () => call<SiteContent>("/api/content"),

  adminMe: () => call<{ admin: boolean; translate: boolean }>("/api/admin/me"),
  adminLogin: (pin: string) =>
    call<{ admin: boolean }>("/api/admin/login", {
      method: "POST",
      body: JSON.stringify({ pin }),
    }),
  adminLogout: () => call<{ admin: boolean }>("/api/admin/logout", { method: "POST" }),

  saveSection: <K extends keyof SiteContent>(key: K, value: SiteContent[K]) =>
    call<{ content: SiteContent }>(`/api/admin/content/${key}`, {
      method: "PUT",
      body: JSON.stringify(value),
    }),

  reset: () => call<{ content: SiteContent }>("/api/admin/reset", { method: "POST" }),

  translate: (text: string) =>
    call<{ text: string }>("/api/admin/translate", {
      method: "POST",
      body: JSON.stringify({ text }),
    }),
};
